export function formatDateToCustomFormat(date) {
    // Obtener la fecha en formato ISO
    let isoString = date.toISOString();

    // Remover el último 'Z' y agregar los milisegundos correctos y la zona horaria
    isoString = isoString.replace(/\.\d{3}Z$/, '.0000000+00:00');

    return isoString;
}


export function convertToISOString(dateString) {
    const [day, month, year] = dateString.split('/');
    const date = new Date(Number(year), Number(month) - 1, Number(day));
    return date.toISOString();
}

export function formatDate(dateStr, hour = true, barSplit = false, invert = false, useUTC = false) {
    if (!dateStr) return '';
  
    const date = new Date(dateStr);
  
    const day = useUTC ? date.getUTCDate() : date.getDate();
    const month = useUTC ? date.getUTCMonth() + 1 : date.getMonth() + 1;
    const year = useUTC ? date.getUTCFullYear() : date.getFullYear();
    const hours = useUTC ? date.getUTCHours() : date.getHours();
    const minutes = useUTC ? date.getUTCMinutes() : date.getMinutes();
  
    const dayStr = day.toString().padStart(2, '0');
    const monthStr = month.toString().padStart(2, '0');
    const yearStr = year.toString();
    const hourStr = hours.toString().padStart(2, '0');
    const minuteStr = minutes.toString().padStart(2, '0');
  
    const separator = barSplit ? '/' : '-';
  
    const datePart = invert
      ? `${dayStr}${separator}${monthStr}${separator}${yearStr}`
      : `${yearStr}${separator}${monthStr}${separator}${dayStr}`;
  
    return hour ? `${datePart} ${hourStr}:${minuteStr}` : datePart;
  }
  

export function formatDateToTime(date) {
    if (!date) return '';
    const d = new Date(date);
    return d.getHours().toString().padStart(2, '0') + ':' + d.getMinutes().toString().padStart(2, '0');
  }